module.exports = __webpack_public_path__ + "img/bg_container.e1025a14.jpg";